import {
    Events
} from 'backbone';
import {
    _
} from 'wgnet-awesomejs';
import BaseErrorField from 'registration/js/base/fields/error';

import template from 'registration/templates/new/fields/error.html';
import highlightLoginTemplate from 'registration/templates/new/fields/login_highlight.html';
import { getPasswordFlow } from 'registration/js/lib/get_field_flow';

const emiter = Object.assign({
    pool: [],
    add(field, silent) {
        this.pool = _.unique(this.pool.concat(field));
        if (!silent) {
            this.trigger('addhint', { field });
        }
    },
    remove(field) {
        this.pool = _.reject(this.pool, (_field) => _field === field);
        this.trigger('removehint', { field });
    },
    count() {
        return this.pool.length;
    },
    contain(field) {
        return _.contains(this.pool, field);
    }
}, Events);

const ErrorField = BaseErrorField.extend({
    template,
    highlightLoginTemplate,
    errorClass: 'error',
    wrapperModifierClass: 'form-input__validate',
    iconModifierPrefix: 'form-input_validate-ico__',
    fixHintPosition() {
        const $hint = this.$fieldset.find('.js-form-field-hint-error');
        const top = 32 - ($hint.outerHeight() / 2);
        $hint.css({ top });
    },
    initEvents(...args) {
        BaseErrorField.prototype.initEvents.apply(this, args);
        emiter.on('addhint', this.hideHint, this);
        emiter.on('showhint', this.hideHint, this);
        emiter.on('removehint', this.showHint, this);
        this.$input.on('focus', _.bind(this.showHint, this));
        this.$el.on('click', () => {
            emiter.lastFocus = this.fieldName;
            this.showHint({});
            emiter.trigger('showhint', { field: this.fieldName });
        });
    },
    afterInitialize(...args) {
        BaseErrorField.prototype.afterInitialize.apply(this, args);
        if (this.fieldName !== 'country_code' && getPasswordFlow() === 'no_repeat') {
            this.$icon.addClass(`${this.iconModifierPrefix}show-password`);
        }
    },
    initElements(...args) {
        BaseErrorField.prototype.initElements.apply(this, args);
        this.$hint = this.$('.js-form-field-hint-error');
    },
    showHint({ field }) {
        const fieldSuggested = this.getFieldState('suggested-state');
        const shortInfoMsgExist = this.getFieldState('short-message-state');
        const currentField = field === this.fieldName;
        if (currentField || !(fieldSuggested || shortInfoMsgExist)) {
            return;
        }

        const focus = this.$input.is(':focus');
        const lastFocus = emiter.lastFocus === this.fieldName;
        if (focus) {
            emiter.lastFocus = this.fieldName;
            emiter.trigger('showhint', { field: this.fieldName });
        }
        const state = (lastFocus || focus || emiter.count() === 1) ? 2 : 1;
        this.toggleSuggestedHint({ field, state });
    },
    hideHint({ field }) {
        if (field === this.fieldName || this.$hint.hasClass('hidden')) {
            return;
        }
        const suggestedState = this.getFieldState('suggested-state');
        const shortMessageState = this.getFieldState('short-message-state');
        const st = suggestedState || shortMessageState;
        const focus = this.$input.is(':focus') || emiter.lastFocus === this.fieldName;
        let state;
        if (st) {
            state = focus ? 2 : 1;
        } else {
            state = 0;
        }
        this.toggleSuggestedHint({ field, state });
    },
    toggleSuggestedHint({ state }) { // state: 0 || false = close, 2 = open, 1 = only msg open
        if (state === 0) {
            this.$hint.addClass('hidden');
        } else if (state === 1) {
            this.$hint.removeClass('hidden');
            this.$('.js-expanded').addClass('hidden');
            this.$('.js-shrinked').removeClass('hidden');
            this.fixHintPosition();
        } else if (state === 2) {
            this.$hint.removeClass('hidden');
            this.$('.js-expanded').removeClass('hidden');
            this.$('.js-shrinked').addClass('hidden');
            this.fixHintPosition();
        }
    },
    showSuggested(...args) {
        BaseErrorField.prototype.showSuggested.apply(this, args);
        emiter.add(this.fieldName);
        this.showHint({});
    },
    hideSuggested(...args) {
        BaseErrorField.prototype.hideSuggested.apply(this, args);
        emiter.remove(this.fieldName);
        this.hideHint({});
    },
    renderErrors(options = {}) {
        if (options.shortInfoMsg && !options.suggestions) {
            options.hasSuggestion = false;
            options.hintMsg = options.shortInfoMsg;
        }
        BaseErrorField.prototype.renderErrors.call(this, options);
        this.setFieldState('short-message-state', !!options.shortInfoMsg);
        if (this.getFieldState('error-state')) {
            this.$el.trigger('field.description.hide');
        }
        this.showHint({});
    },
    hideError() {
        this.$el.trigger('field.description.show');
        BaseErrorField.prototype.hideError.call(this);
        this.hideHint({});
    },
    setIcon() {
        const iconState = BaseErrorField.prototype.setIcon.call(this);
        const $inputWrapper = this.$fieldset.find('.js-input-wrapper');
        $inputWrapper.toggleClass(this.wrapperModifierClass, !!iconState);
        return iconState;
    }
});

export default ErrorField;
export {
    emiter
};
